import { Directive, TemplateRef, ViewContainerRef, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[plrIfFormStatus],[plrIfValid],[plrIfInvalid]'
})
export class IfFormStatusDirective implements OnDestroy {
  private _control: AbstractControl;
  private _subscription: Subscription;
  private _addedTemplate: boolean = false;

  @Input()
  set plrIfFormStatus(control: AbstractControl) {
    this.updateControl(control);
  }
  @Input()
  set plrIfValid(control: AbstractControl) {
    if(!this.propertyName){
      this.propertyName = 'valid';
    }
    this.updateControl(control);
  }
  @Input()
  set plrIfInvalid(control: AbstractControl) {
    if(!this.propertyName){
      this.propertyName = 'invalid';
    }
    this.updateControl(control);
  }

  @Input()
  propertyName: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private changeDetector: ChangeDetectorRef) { }

    ngOnDestroy() {
      if(this._subscription){
        this._subscription.unsubscribe();
        this._subscription = undefined;
      }
    }

  
  private updateControl(control: AbstractControl) {
    if(this._subscription){
      this._subscription.unsubscribe();
      this._subscription = undefined;
    }
    this._control = control;
    if(this._control){
      this._subscription = this._control.statusChanges.subscribe( () => { this.check()});
    }
  }

  private check(){
    setTimeout(() => {
      if(this._control[this.propertyName]){
        if (!this._addedTemplate) {
          this._addedTemplate = true;
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.changeDetector.markForCheck();
        }
      } else if(this._addedTemplate) {
        this._addedTemplate = false;
        this.viewContainer.clear();
        this.changeDetector.markForCheck();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/common/directives/if-form-status.directive.ts